import types from '../actionTypes';

export const setMap = payload => ({
    type: types.SET_MAP,
    payload,
});
